<template>
  <div>
    <a-spin :spinning="loading">
      <div>
        <div class="custom-section-box">
          <div class="ant-advanced-search-form item">
            <div v-if="editData" style="display: table;">
              <div style="display: flex;margin-bottom: 14px;">
                <div style="flex: 1;">
                  <a-radio-group v-model="currentWebSiteType" @change="handleWebSiteTypeChange">
                    <a-radio-button value="Signet">Signet</a-radio-button>
                    <a-radio-button value="Supera">Supera</a-radio-button>
                  </a-radio-group>
                </div>
                <a class="edit-icon" @click="handleToggleChange" :style="{color: isEditTour ? '' : '#333'}" v-if="!isShowEdit">
                  <a-icon :type="isEditTour ? 'edit' : 'close'" />
                </a>
              </div>
              <div style="padding-bottom: 14px;">
                <cdb-customer-tour-list
                  ref="tourListComponent"
                  v-if="isEditTour" 
                  :customerId="customerId"
                  :tourData="editData"
                  :mealsList="mealsList"
                  :specialList="specialList"
                  :airlineList="airlineList"
                  :ffpList="editData.ffpList"
                  :isEditTour="isEditTour"
                  :isShowEdit="isShowEdit"
                  :isMainShow="isMainShow"
                  @update="handleUpdate"
                />
                <cdb-customer-tour-edit
                  v-if="!isEditTour" 
                  :customerId="customerId"
                  :tourData="editData"
                  :mealsList="mealsList"
                  :specialList="specialList"
                  :ffpList="editData.ffpList"
                  :airlineList="airlineList"
                  :isEditTour="isEditTour"
                  @cancel="isEditTour = true"
                  @update="handleUpdate"
                />
              </div>
            </div>
            <tour-records
              v-if="editData"
              :globalCode="editData.globalCode"
              :customerId="currentWebSiteType == 'Signet' ? editData.signetCustomerId : editData.superaCustomerId"
              :isShowEdit="isShowEdit"
              :isMainShow="isMainShow"
              :currentWebSiteType="currentWebSiteType"
              ref="tourRecordList"
            />
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import CustomerApi from '@/api/api-cdb-custome-v2'
import CdbCustomerTourList from './CdbCustomerTourList'
import CdbCustomerTourEdit from './CdbCustomerTourEdit'
import { Meals, Special } from '@/utils/helper/dict-cdb-utils'
import TourRecords from './tourRecord/CdbCustomerTourRecordList'

export default {
  name: 'CdbCustomerTourPage',
  components: {
    CdbCustomerTourList,
    CdbCustomerTourEdit,
    TourRecords
  },
  props: {
    customerId: {
      type: String,
      required: true
    },
    isShowEdit: {
      type: Boolean,
      default: false
    },
    isMainShow: {
      type: Boolean,
      default: true
    },
    webSiteType: {
      type: String,
      default: 'Signet'
    }
  },
  data () {
    return {
      loading: true,
      isEditTour: true,
      editData: null,
      mealsList: null,
      specialList: null,
      currentWebSiteType: 'Signet',
      airlineList: []
    }
  },
  mounted () {
    this.loadData()
    this.queryAirList()
  },
  methods: {
    async loadData() {
      this.loading = true
      this.mealsList = await Meals.getDict()
      this.specialList = await Special.getDict()
      try {
        const res = await CustomerApi.getCusRequest(this.customerId)
        const data = res.data
        this.editData = data || {}
      } catch (error) {
        console.error('Error loading tour data:', error)
      } finally {
        this.loading = false
      }
    },
    async queryAirList () { 
      try {
        const res = await CustomerApi.getAirServiceList()
        this.airlineList = res.data || []
      } catch (error) {
        console.error('Error loading airline list:', error)
      }
    },
    handleToggleChange () {
      this.isEditTour = !this.isEditTour
    },
    handleUpdate () {
      this.loadData()
      this.isEditTour = true
      this.$emit('update')
    },
    handleWebSiteTypeChange (e) {
      this.currentWebSiteType = e.target.value
      if (this.$refs.tourRecordList) {
        this.$refs.tourRecordList.loadData({ pageNo: 1, pageSize: 100 })
      }
      this.$emit('web-site-type-change', this.currentWebSiteType)
    }
  },
  watch: {
    webSiteType(newVal) {
      this.currentWebSiteType = newVal
      if (this.$refs.tourRecordList) {
        this.$refs.tourRecordList.loadData({ pageNo: 1, pageSize: 100 })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.custom-section-box {
  .item ::v-deep .ant-col {
    padding-top: 0;
  }
}
.edit-icon {
  display: block;
  text-align: right;
  font-size: 16px;
}
</style>
